module.exports = __webpack_public_path__ + "img/item4.fae0962a.svg";